import styled from 'styled-components';

import { FONTS } from 'constants/fonts';

export const BodyContainer = styled.div`
  margin-top: 8px;
  margin-bottom: 8px;
  margin-left: 16px;
  margin-right: 16px;
`;

export const MediaGridContainer = styled.div<{ itemCount: number }>`
  display: grid;
  grid-template-columns: ${(props) => {
    if (props.itemCount === 1) {
      return '1fr';
    }
    if (props.itemCount === 3) {
      return '1fr 1fr';
    }
    if (props.itemCount === 2 || props.itemCount === 4) {
      return '1fr 1fr';
    }
    return '1fr 1fr';
  }};
  ${(props) =>
    props.itemCount === 3 &&
    `
    & > div:nth-child(1) {
      grid-row: span 2;
    }
  `}
`;

export const MediaItem = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  height: auto;
  padding: 2px;
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  z-index: 10;
  cursor: pointer;
`;

export const OverlayText = styled.span`
  color: white;
  font-size: ${FONTS.OVERLAY_FONT};
  font-weight: bold;
`;
